module.exports = __webpack_public_path__ + "media/images/powerpoint/bordeaux-fete-le-vin-background-20dc80ec54852fafdcb9bf23ee0ff41f.png";